// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"186":"c9272f86","326":"807a5069","358":"3774207c","487":"ccb7d813","574":"42480d2a","589":"b79af157","723":"27294f3b","732":"049c5ebc","846":"aebb9722","857":"22b99197","876":"a38d033d","889":"eac940ca","996":"0dd545d9"}[chunkId] + ".js";
};